import { render, staticRenderFns } from "./PopupConcAmount.vue?vue&type=template&id=2da3b098&scoped=true"
import script from "./PopupConcAmount.vue?vue&type=script&lang=js"
export * from "./PopupConcAmount.vue?vue&type=script&lang=js"
import style0 from "./PopupConcAmount.vue?vue&type=style&index=0&id=2da3b098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3b098",
  null
  
)

export default component.exports